import { useQuery } from "@tanstack/react-query"
import axiosServices from "@pma/utils/axios"
import {
  GET_LATEST_FILES,
  USED_SPACE_STATISTICS_ENDPOINT,
  PROJECTS_BY_CURRENT_USER_FILTER,
} from "@pma/utils/api-routes"

export function useFileQueries(orgId: number | undefined) {
  const {
    data: filesRaw,
    isLoading: filesLoading,
    error: filesError,
    refetch: refetchFiles,
  } = useQuery<any[]>({
    queryKey: ["file-analytics-files", orgId],
    queryFn: async () => {
      const res = await axiosServices.get(GET_LATEST_FILES, {
        params: { organization_id: orgId },
      })
      return res.data?.items || res.data || []
    },
    enabled: !!orgId,
    staleTime: 60_000,
  })

  const {
    data: usedSpaceRaw,
    isLoading: spaceLoading,
  } = useQuery<any>({
    queryKey: ["file-analytics-space", orgId],
    queryFn: async () => {
      const res = await axiosServices.get(USED_SPACE_STATISTICS_ENDPOINT, {
        params: { company_id: orgId },
      })
      return res.data
    },
    enabled: !!orgId,
    staleTime: 60_000,
  })

  const { data: projectsRaw } = useQuery<any[]>({
    queryKey: ["file-analytics-projects", orgId],
    queryFn: async () => {
      const res = await axiosServices.post(PROJECTS_BY_CURRENT_USER_FILTER, {
        paging_start_page: 1,
        paging_per_page: 100,
        by_organization_id: orgId,
      })
      return res.data?.items || res.data || []
    },
    enabled: !!orgId,
    staleTime: 60_000,
  })

  const isLoading = filesLoading || spaceLoading

  return {
    filesRaw,
    usedSpaceRaw,
    projectsRaw,
    isLoading,
    filesError,
    refetchFiles,
  }
}
